import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Auth } from '../../config/configuration/react';
import useLocalStorage from '../useLocalStorage/useLocalStorage';
import getConcessionsApi from '../../services/Form/getConcessionsApi';
import getUsers from '../../services/Form/getUsers';
import getSourcesApi from '../../services/Form/getSourcesApi';

export const useConcessionsBuyersFilters = (mode = 'search') => {
  const userId = Auth.userId();
  const sourceId = useSelector((state) => state.recordList.filters?.sourceId);
  const selectedSources = useSelector((state) => state.recordList.filtersSupervisor?.sourceIds);
  const currentTab = useSelector((state) => state.recordList.currentTab);
  const [sourcesLS, setSourcesLocalS] = useLocalStorage(`${userId}.sources`, []);
  const [concessionsLS, setConcessionsLocalS] = useLocalStorage(`${userId}.concession`, []);
  const [concessionsLSearch, setConcessionsLSearch] = useLocalStorage(`${userId}.search.concession`, []);
  const [buyersLS, setBuyersLocalS] = useLocalStorage(`${userId}.buyers`, []);
  const isMounted = useRef(false);
  useEffect(() => {
    if (mode !== 'search') {
      if (selectedSources && selectedSources.length > 0) {
        getConcessionsApi({ value: selectedSources }).then((concessions) => {
          if (!isMounted.current) setConcessionsLocalS(concessions);
        });
        getUsers(selectedSources).then((buyer) => {
          if (!isMounted.current) setBuyersLocalS(buyer);
        });
      } else {
        if (!sourcesLS || sourcesLS.length === 0) {
          getSourcesApi().then((sources) => {
            if (!isMounted.current) setSourcesLocalS(sources);
          });
        }
        getConcessionsApi().then((concessions) => {
          if (!isMounted.current) setConcessionsLocalS(concessions);
        });
        if (!buyersLS || buyersLS.length === 0) {
          getUsers().then((buyer) => {
            if (!isMounted.current) setBuyersLocalS(buyer);
          });
        }
      }
    } else if (sourceId?.value !== null) {
      if (!sourcesLS || sourcesLS.length === 0) {
        getSourcesApi().then((sources) => {
          if (!isMounted.current) setSourcesLocalS(sources);
        });
      }
      setConcessionsLSearch(null);
      getConcessionsApi(sourceId).then((concessions) => {
        if (!isMounted.current) setConcessionsLSearch(concessions);
      });
      getUsers().then((buyer) => {
        if (!isMounted.current) setBuyersLocalS(buyer);
      });
    } else {
      if (!sourcesLS || sourcesLS.length === 0) {
        getSourcesApi().then((sources) => {
          if (!isMounted.current) setSourcesLocalS(sources);
        });
      }
      getConcessionsApi().then((concessions) => {
        if (!isMounted.current) setConcessionsLSearch(concessions);
      });
      if (!buyersLS || buyersLS.length === 0) {
        getUsers().then((buyer) => {
          if (!isMounted.current) setBuyersLocalS(buyer);
        });
      }
    }
  }, [sourceId, selectedSources, currentTab]);

  return { concessionsLS, buyersLS, sourcesLS, concessionsLSearch };
};
